import React from 'react'
import AboutIntro from '../Components/AboutPageComponents/AboutIntro'
import AboutServices from '../Components/AboutPageComponents/AboutServices'
import AboutProcess from '../Components/AboutPageComponents/AboutProcess'

const AboutUsPage = () => {
  return (
    <div className=' pt-20 '>
        <AboutIntro/>
        <AboutServices />
        <AboutProcess />
    </div>
  )
}

export default AboutUsPage